
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class PaginationMixin extends Vue {
  dataList = [];

  PaginationDetail: any = {};

  paginationParams: any = {};

  resultData: any = {};

  WinLoseList: any = {};

  dataKey = '';

  calPagination({ instance, dataKey }) {
    this.paginationParams = {
      instance,
      dataKey,
    };
    this.PaginationDetail.amount = this[instance].pageAmount;
    const { size, current } = this.PaginationDetail;
    this.dataList = this[instance][dataKey]
      .slice((current - 1) * size, (current * size));
    if (instance === 'WinLoseList') {
      this.resultData = { ...this.WinLoseList };
      this.resultData[this.dataKey] = [...this.dataList];
    }
  }

  changePage(i) {
    this.PaginationDetail.current = i;
    this.calPagination({ ...this.paginationParams });
  }
}
